import { gql } from '@apollo/client'
import { Authentication } from 'share/domain/authentication'
// mobile phone change section

export const UPDATE_ACCOUNT_MOBILE_PHONE = gql`
  mutation UPDATE_ACCOUNT_MOBILE_PHONE(
    $updateMobilePhoneData: UpdateAccountMobilePhoneDtoInput!
  ) {
    accounts {
      updateAccountMobilePhone(request: $updateMobilePhoneData) {
        success
        errorMessage
      }
    }
  }
`

export interface UpdateAccountMobilePhoneResponse {
  accounts: {
    updateAccountMobilePhone: UpdateAccountMobilePhoneResponseData
  }
}

export interface UpdateAccountMobilePhoneResponseData {
  success: boolean
  errorMessage: string | null | undefined
}

export interface UpdateAccountMobilePhoneVariables {
  updateMobilePhoneData: {
    mobilePhoneNumber: string
  }
}

export const VERIFY_UPDATED_MOBILE_PHONE = gql`
  mutation VERIFY_UPDATED_MOBILE_PHONE(
    $verifyMobilePhoneData: VerifyUpdatedMobilePhoneDtoInput!
  ) {
    accounts {
      verifyUpdatedMobilePhone(request: $verifyMobilePhoneData) {
        success
        errorMessage
      }
    }
  }
`

export interface VerifyUpdatedMobilePhoneResponse {
  accounts: {
    verifyUpdatedMobilePhone: VerifyUpdatedMobilePhoneResponseData
  }
}

export interface VerifyUpdatedMobilePhoneResponseData {
  success: boolean
  errorMessage: string | null | undefined
}

export interface VerifyUpdatedMobilePhoneVariables {
  verifyMobilePhoneData: {
    code: string
  }
}

export const RESEND_UPDATED_MOBILE_PHONE_CODE = gql`
  mutation RESEND_UPDATED_MOBILE_PHONE_CODE {
    accounts {
      resendUpdatedMobilePhoneCode {
        success
      }
    }
  }
`

export interface ResendUpdatedMobilePhoneCodeResponse {
  accounts: {
    resendUpdatedMobilePhoneCode: ResendUpdatedMobilePhoneCodeResponseData
  }
}

export interface ResendUpdatedMobilePhoneCodeResponseData {
  success: boolean
}

export const CANCEL_UPDATED_MOBILE_PHONE = gql`
  mutation CANCEL_UPDATED_MOBILE_PHONE {
    accounts {
      cancelUpdateAccountMobilePhone {
        success
        errorMessage
        mobilePhoneNumber
      }
    }
  }
`

export interface CancelUpdatedMobilePhoneResponse {
  accounts: {
    cancelUpdateAccountMobilePhone: CancelUpdatedMobilePhoneResponseData
  }
}

export interface CancelUpdatedMobilePhoneResponseData {
  success: boolean
  errorMessage: string | null | undefined
  mobilePhoneNumber: string | null
}

// email address change section

export const UPDATE_ACCOUNT_EMAIL_ADDRESS = gql`
  mutation UPDATE_ACCOUNT_EMAIL_ADDRESS(
    $updateEmailAddressData: UpdateAccountEmailAddressDtoInput!
  ) {
    accounts {
      updateAccountEmailAddress(request: $updateEmailAddressData) {
        success
        errorMessage
      }
    }
  }
`

export interface UpdateAccountEmailAddressResponse {
  accounts: {
    updateAccountEmailAddress: UpdateAccountEmailAddressResponseData
  }
}

export interface UpdateAccountEmailAddressResponseData {
  success: boolean
  errorMessage: string | null | undefined
}

export interface UpdateAccountEmailAddressVariables {
  updateEmailAddressData: {
    emailAddress: string
  }
}

export const VERIFY_UPDATED_EMAIL_ADDRESS = gql`
  mutation VERIFY_UPDATED_EMAIL_ADDRESS(
    $verifyEmailAddressData: VerifyUpdatedEmailAddressDtoInput!
  ) {
    accounts {
      verifyUpdatedEmailAddress(request: $verifyEmailAddressData) {
        success
        errorMessage
      }
    }
  }
`

export interface VerifyUpdatedEmailAddressResponse {
  accounts: {
    verifyUpdatedEmailAddress: VerifyUpdatedEmailAddressResponseData
  }
}

export interface VerifyUpdatedEmailAddressResponseData {
  success: boolean
  errorMessage: string | null | undefined
}

export interface VerifyUpdatedEmailAddressVariables {
  verifyEmailAddressData: {
    code: string
  }
}

export const RESEND_UPDATED_EMAIL_ADDRESS_CODE = gql`
  mutation RESEND_UPDATED_EMAIL_ADDRESS_CODE {
    accounts {
      resendUpdatedEmailAddressCode {
        success
      }
    }
  }
`

export interface ResendUpdatedEmailAddressCodeResponse {
  accounts: {
    resendUpdatedEmailAddressCode: ResendUpdatedEmailAddressCodeResponseData
  }
}

export interface ResendUpdatedEmailAddressCodeResponseData {
  success: boolean
}

export const CANCEL_UPDATED_EMAIL_ADDRESS = gql`
  mutation CANCEL_UPDATED_EMAIL_ADDRESS {
    accounts {
      cancelUpdateAccountEmailAddress {
        success
        errorMessage
        emailAddress
      }
    }
  }
`

export interface CancelUpdatedEmailAddressResponse {
  accounts: {
    cancelUpdateAccountEmailAddress: CancelUpdatedEmailAddressResponseData
  }
}

export interface CancelUpdatedEmailAddressResponseData {
  success: boolean
  errorMessage: string | null | undefined
  emailAddress: string | null
}

// account creation contact info change

export const UPDATE_ACCOUNT_CONTACT_INFO = gql`
  mutation UPDATE_ACCOUNT_CONTACT_INFO(
    $acctContactInfo: UpdateAccountContactInfoDtoInput!
  ) {
    accounts {
      updateAccountContactInfo(request: $acctContactInfo) {
        success
        verifyPhone
        verifyEmail
      }
    }
  }
`

export interface UpdateAccountContactInfoResponse {
  accounts: {
    updateAccountContactInfo: UpdateAccountContactInfoResponseData
  }
}

export interface UpdateAccountContactInfoResponseData {
  success: boolean
  verifyPhone: boolean
  verifyEmail: boolean
  error: string | null | undefined
}

export interface UpdateAccountContactInfoVariables {
  acctContactInfo: {
    userName: string
    invitationGuid: string
    mobilePhone: string | null
    emailAddress: string | null
    contactType: number
  }
}

export const UPDATE_ACCOUNT = gql`
  mutation UPDATE_ACCOUNT($account: AccountDtoInput!) {
    accounts {
      update(request: $account) {
        id
        givenName
        middleName
        suffix
        familyName
        homePhone
        mobilePhone
        workPhone
        userName
        emailAddress
        street
        zip
        city
        state
        ssn
        caseCount
        accountCreationStep
        contactType
      }
    }
  }
`

export interface UpdateAccountResponse {
  accounts: {
    update: UpdateAccountResponseData
  }
}

export interface UpdateAccountResponseData {
  id: number
  givenName: string | null
  middleName: string | null
  familyName: string | null
  suffix: string | null
  homePhone: string | null
  workPhone: string | null
  mobilePhone: string | null
  userName: string
  emailAddress: string | null
  street: string | null
  city: string | null
  state: string | null
  zip: string | null
  ssn: string | null
  caseCount: number
  contactType: number
  success?: boolean
  error?: string | null
}

export interface UpdateAccountVariables {
  account: {
    id: number
    givenName: string | null
    middleName: string | null
    familyName: string | null
    suffix: string | null
    homePhone: string | null
    workPhone: string | null
    mobilePhone: string | null
    userName: string
    emailAddress: string
    street: string | null
    city: string | null
    state: string | null
    zip: string | null
    ssn: string | null
    contactType: number
    accountCreationStep: number
  }
}

// UserProfileResetPasswrod mutations start

export const CHANGE_PASSWORD = gql`
  mutation CHANGE_PASSWORD(
    $newPassword: String!
    $oldPassword: String!
    $userName: String!
  ) {
    authentication {
      changePassword(
        newPassword: $newPassword
        oldPassword: $oldPassword
        userName: $userName
      )
    }
  }
`

export interface ChangePasswordVariables {
  newPassword: string
  oldPassword: string
  userName: string
}

export interface ChangePasswordResponse {
  authentication: {
    changePassword: boolean
  }
}

export interface ChangePasswordResponseData {
  success: boolean
  error: string | null
}

// UserProfileResetPasswrod mutations finish

// forgot form start

export const RESET_CREDENTIALS = gql`
  mutation RESET_CREDENTIALS(
    $lastName: String!
    $mobilePhone: String!
    $forgotUser: Boolean!
    $forgotPassword: Boolean!
  ) {
    authentication {
      resetCredentials(
        lastName: $lastName
        mobilePhone: $mobilePhone
        forgotUser: $forgotUser
        forgotPassword: $forgotPassword
      ) {
        userName
        message
        maskedEmail
        accountId
        success
        noAccountFlag
        hasNotCompletedAccountSetupSteps
      }
    }
  }
`

export interface ResetCredentialsVariables {
  lastName: string
  mobilePhone: string
  forgotUser: boolean
  forgotPassword: boolean
}

export interface ResetCredentialsResponseData {
  userName: string
  message: string
  maskedEmail: string
  accountId: number
  success: boolean
  noAccountFlag: boolean
  hasNotCompletedAccountSetupSteps: boolean
}

export interface ResetCredentialsResponse {
  authentication: {
    resetCredentials: ResetCredentialsResponseData
  }
}

// forgot form finish

// ResetPasswordForm mutations start

export const RESET_PASSWORD = gql`
  mutation CONFIRM_RESET_CREDENTIALS(
    $code: String!
    $newPassword: String!
    $accountId: Int!
  ) {
    authentication {
      confirmResetCredentials(
        code: $code
        newPassword: $newPassword
        accountId: $accountId
      ) {
        idToken
        accessToken
        expirationTime
        requiresMfa
        sessionId
        account {
          givenName
          familyName
          middleName
          suffix
          homePhone
          workPhone
          userName
          emailAddress
          street
          zip
          city
          state
          ssn
          caseCount
          accountCreationStep
          contactType
        }
      }
    }
  }
`

export interface ResetPasswordVariables {
  code: string
  newPassword: string
  accountId: number
}

export interface ResetPasswordResponse {
  authentication: {
    confirmResetCredentials: Authentication
  }
}

export interface ResetPasswordResponseData {
  success: boolean
  error: string | null
}

// ResetPasswordForm mutations finish

// Account Creation - Verify Your Phone Number start

export const ENABLE_MFA = gql`
  mutation {
    authentication {
      enableMfa
    }
  }
`

export interface EnableMfaResponse {
  authentication: {
    enableMfa: boolean
  }
}
// Account Creation - Verify Your Phone Number finish
